import type { JSONContent } from '@shared/models';
import { LessonDto, MediaDto } from './lesson.dto';
import { LessonType } from './lesson.type';

export class Lesson {
    id: string;
    name: string;
    placeholder: string | null;
    title: string | null;
    description: string | null;
    duration: number | null;
    media: Media;
    materialIds: string[];
    transcription: JSONContent | null;
    completionEnforcement: boolean;

    constructor(data: LessonDto) {
        this.id = data.id;
        this.name = data.name;
        this.placeholder = data.placeholder;
        this.title = data.title;
        this.description = data.description;
        this.duration = data.duration;
        this.media = new Media(data.media);
        this.transcription = data.transcription ?? null;
        this.materialIds = data.materialIds ?? [];
        this.completionEnforcement = data.completionEnforcement;
    }
}

export class Media {
    type: LessonType;
    id: string | null;

    constructor(data?: MediaDto) {
        this.type = data?.type ?? 'text';
        this.id = data?.id ?? null;
    }
}
